export default {"src":"/_next/static/media/Group-25836.f61da54c.svg","height":104,"width":104};